import getIn from 'transmute/getIn';
export const getTimeOnPageTriggerTimeoutId = getIn(['timeOnPageTrigger', 'timeoutId']);